module.exports = __webpack_public_path__ + "img/3.5038d20a.png";